import { inject, Injectable } from "@angular/core";
import { NgbDatepickerI18n } from "@ng-bootstrap/ng-bootstrap";
import { TranslationService } from "src/app/i18n";

const I18N_VALUES = {
  th: {
    weekdays: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
    months: [
      "มกราคม",
      "กุมภาพันธ์",
      "มีนาคม",
      "เมษายน",
      "พฤษภาคม",
      "มิถุนายน",
      "กรกฎาคม",
      "สิงหาคม",
      "กันยายน",
      "ตุลาคม",
      "พฤศจิกายน",
      "ธันวาคม",
    ],
  },
  en: {
    weekdays: ["S", "M", "T", "W", "TH", "F", "SA"],
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
  },
};

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  #translate = inject(TranslationService);
  private locale: "th" | "en" = this.#translate.getSelectedLanguage();

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this.locale as "th" | "en"].weekdays[weekday - 1];
  }

  getWeekdayLabel(
    weekday: number,
    width?: "long" | "short" | "narrow"
  ): string {
    // ✅ method ใหม่ที่ต้อง implement
    return I18N_VALUES[this.locale as "th" | "en"].weekdays[weekday - 1];
  }

  getMonthShortName(month: number): string {
    return I18N_VALUES[this.locale as "th" | "en"].months[month - 1];
  }

  getMonthFullName(month: number): string {
    return I18N_VALUES[this.locale as "th" | "en"].months[month - 1];
  }

  getDayAriaLabel(date: { day: number; month: number; year: number }): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}
